import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconExpand45: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-filled-radius-0-stroke-1.5-IconExpand45"><Path fillRule="evenodd" clipRule="evenodd" d="M13 3H21V11H19.5V5.56066L13.75 11.3107L12.6893 10.25L18.4393 4.5H13V3ZM11.3107 13.75L5.56066 19.5H11V21H3V13H4.5V18.4393L10.25 12.6893L11.3107 13.75Z" fill="currentColor"/></CentralIconBase>;
});

export default IconExpand45;
